import axios from 'axios';

const api = axios.create({
    timeout: 60000,
    transformRequest: [...axios.defaults.transformRequest, (data, headers) => {
        delete headers.common['X-Requested-With'];
        return data;
    }]
});

export default api;
